import type { CSSProperties } from "react";
import { Toaster as Sonner } from "sonner";
import { CircleCheck, CircleX, Info, TriangleAlert, LoaderCircle } from "lucide-react";
import { useTheme } from "@/shared/hooks/useTheme";

export function Toaster() {
  const { theme, darkMode } = useTheme();
  const resolvedTheme = theme === 'system' ? (darkMode ? 'dark' : 'light') : theme;
  return (
    <Sonner
      theme={resolvedTheme}
      style={{
        "--normal-bg": "var(--card)",
        "--normal-border": "var(--border)",
        "--normal-text": "var(--card-foreground)",
      } as CSSProperties & Record<string, string>}
      position="top-center"
      duration={5000}
      closeButton
      icons={{
        success: <CircleCheck className="h-5 w-5 text-success" />,
        error: <CircleX className="h-5 w-5 text-destructive" />,
        info: <Info className="h-5 w-5 text-info" />,
        warning: <TriangleAlert className="h-5 w-5 text-warning" />,
        loading: <LoaderCircle className="h-5 w-5 text-info animate-spin" />,
      }}
    />
  );
}
